export const text = {
  pageTitle: "Cookies Policy",
};
